"use client";

import { useEffect } from "react";
import { reportClientError } from "@/components/errors/report";

// Last-resort boundary (the root layout itself failed): no i18n provider here, so keep it minimal and bilingual-neutral.
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    reportClientError(error, "global");
  }, [error]);
  return (
    <html lang="en">
      <body style={{ fontFamily: "system-ui, sans-serif", padding: "4rem 1rem", textAlign: "center" }}>
        <h1>Something went wrong · Une erreur est survenue · حدث خطأ ما</h1>
        {error.digest && <p style={{ color: "#667" }}>Ref: <code>{error.digest}</code></p>}
        <button type="button" onClick={() => reset()} style={{ marginTop: 16, padding: "8px 16px" }}>Try again · Réessayer · حاول مرة أخرى</button>
      </body>
    </html>
  );
}
